import styled, { css, keyframes } from "styled-components";

interface IContainerProps {
  open: boolean;
}

const slideIn = keyframes`
  0%{
    transform: translateX(-100%);
  }
  100%{
    transform: translateX(0);
  }
`;

const openMenu = css`
  animation: ${slideIn} 350ms ease forwards;
`;

export const Container = styled.div<IContainerProps>`
  z-index: 3;
  position: absolute;
  top: 0;
  left: 0;
  bottom: 0;
  width: 100%;
  height: 100%;
  color: #232323;
  /* border-right: 1px solid #dddddd; */
  background: transparent;

  @media screen and (max-width: 1023px) {
    transform: translateX(-100%);
    ${(props) => props.open && openMenu};
    background: white;
  }

  @media (min-width: 420px) {
    width: 240px;
  }

  @media (min-width: 1600px) {
    width: 250px;
  }
`;

export const BrandWrapper = styled.div`
  box-shadow: -4px 3px 5px #d1d1d1;
  background-color: #205aa7;
  color: #fff;
  z-index: 100;

  @media screen and (max-width: 1023px) {
    box-shadow: none;
    background-color: #fff;
    color: black;
    background-color: #205aa7;
  }
`;

export const NavigatorWrapper = styled.div`
  margin: 20px 5px 20px 10px;
  height: calc(100vh - 90px);
  background: white;
  border-radius: 5px;
`;
